<template>
  <div class="modal-SOSSet">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">SOS设置</div>
        <button type="button" class="btn-close" @click="closeSelf">关闭</button>
      </div>
      <div class="modal-body">
        <el-tabs type="border-card" :before-leave='beforeLeave' v-model="activeName" style="height:598px">
          <el-tab-pane v-for="(item,i) in tableData" :key="i" :label="item.name">
            <component :is="item.currentRole" ref="component"/>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>

import BaiduMapRail from "./BaiduMapRail";
import BaiduMapReal from "./BaiduMapReal";
import BaiduMapMotionCurve from "./BaiduMapMotionCurve";
import SOSContacts from "./SOSContacts";
import WhiteContacts from "./WhiteContacts";
import WeiLanAlarm from "./WeiLanAlarm";


export default {
  name: "PageForDevice",
  data() {
    return {
      userCode: '',
      WeiLanAlarmShow:false,
      whiteContactsShow: false,
      SOSContacts: false,
      baiduMapMotionCurveShow: false,
      baiduMapRealShow: false,
      activeName:'0',
      baiduMapRailShow: false,
      lon: '',
      lat: '',
      address: '',
      tableData: [
        {name: '围栏设置',currentRole:'BaiduMapRail',isNone:true},
        {name: '运动轨迹',currentRole:'BaiduMapMotionCurve',isNone:false},
        {name: '实时定位',currentRole:'BaiduMapReal',isNone:false},
        {name: 'sos联系人',currentRole:'SOSContacts',isNone:false},
        {name: '白名单联系人',currentRole:'WhiteContacts',isNone:false},
        {name: '围栏报警提醒',currentRole:'WeiLanAlarm',isNone:false},
      ],
    }
  },
  components: {
    SOSContacts, BaiduMapRail, BaiduMapReal, BaiduMapMotionCurve, WhiteContacts,WeiLanAlarm
  },

  methods: {
    init(row) {
      this.userCode = row.userCode;
      this.activeName='0'
      this.tableData.forEach((item)=>{
        item.isNone=false
      })
      this.tableData[0].isNone=true
      this.$nextTick(() => {
        this.$refs.component[0].init(row.userCode)
      })
    },
    closeSelf() {
      this.$emit("closeSOSSetPage");
    },
    beforeLeave(activeName){
        if(!this.tableData[parseInt(activeName)].isNone){
            this.tableData[parseInt(activeName)].isNone=true
            this.$nextTick(() => {
                this.$refs.component[parseInt(activeName)].init(this.userCode)
            })
        }
    }

  },

}


</script>

<style lang="scss" scoped>

.modal-SOSSet {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, .3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;

  .modal {
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    width: 1000px;

    .modal-header {
      border-bottom: 1px solid #eee;
      color: #313131;
      justify-content: space-between;
      padding: 10px;
      display: flex;
    }

    .modal-body {
      position: relative;
      padding: 20px;
      z-index: 99;
      height:600px;
      /deep/.el-tabs--border-card {
        box-shadow:none;
        .el-tabs__content{
          padding: 3px;
        }
      }
    }


  }

}


.btn-close, .btn-confirm {
  border-radius: 8px;
  margin-left: 16px;
  width: 56px;
  height: 36px;
  border: none;
  cursor: pointer;
}

.btn-close {
  color: #313131;
  background-color: transparent;
}


.row {
  padding: 10px 0px;
}

.item {
  padding: 0px 20px;
}

.label {
  padding: 5px 0px;
}

</style>